import { FieldMetaState } from 'react-final-form';

import { MDText } from 'i18n-react';

import { INTENT } from 'Utilities/formValidators';
import { VRM_CHECK_CODES } from 'Utilities/vrm';

import VRMErrorTexts from '../../../fastlane/homeVRM/homeVRMErrors/HomeVRMErrorsTexts.json';

const VrmErrorT = new MDText(VRMErrorTexts);

const getFieldIntent = (meta: FieldMetaState<string>) => {
  if ((meta.pristine && !meta.submitFailed) || meta.submitting) {
    return undefined;
  }

  if (meta.valid) {
    return INTENT.SUCCESS;
  }

  if (meta.submitFailed && !meta.modifiedSinceLastSubmit) {
    return INTENT.ERROR;
  }
  if (meta.error && !meta.active) {
    return INTENT.ERROR;
  }

  return undefined;
};

const getVrmErrorTexts = (error:string, vrm?:string) => {
  const t = (key: string, options?: Record<string, unknown>) =>
    `${VrmErrorT.translate(key, options)}`;

  const [title, detail] = {
    [VRM_CHECK_CODES.EXCEEDED]: [
      t('exceeded.title', { vrm }),
      t('exceeded.detail'),
    ],
    [VRM_CHECK_CODES.INVALID_VRM]: [
      t('invalid_vrm.title', { vrm }),
      t('invalid_vrm.detail'),
    ],
    [VRM_CHECK_CODES.TOO_MANY_REQUESTS]: [
      t('too_many_requests.title'),
      t('too_many_requests.detail'),
    ],
    [VRM_CHECK_CODES.VEHICLE_GENERATION_FAILURE]: [
      t('vehicle_generation_failure.title'),
      t('vehicle_generation_failure.detail'),
    ],
    [VRM_CHECK_CODES.VEHICLE_LOOKUP_FAILED]: [
      t('vehicle_lookup_failed.title'),
      t('vehicle_lookup_failed.detail'),
    ],
  }[error] || [
    t('trackerDefault.title'),
    t('trackerDefault.detail'),
  ];

  return { detail, title };
};

const helpers = {
  getFieldIntent,
  getVrmErrorTexts,
};

export default helpers;
